<template>
    <div class="card-text-wrap">
        <em v-if="!checkCard">등록된 이마티콘이 없습니다.</em>
        <span v-if="checkCard" class="emarticon-card-subject">{{ checkCard.prepaidCardNickName != null? checkCard.prepaidCardNickName : checkCard.giftMessage != null? checkCard.giftMessage : '' }}</span>
        <span v-if="checkCard" class="emarticon-card-price">{{ Number(checkCard.remainCash).toLocaleString() }}</span>
        <button v-if="checkCard" class="absolute-barcode" title="바코드 화면보기"></button>
    </div>
</template>

<script>
export default {
    name: 'PublishCardText',
    props: ['checkCard'],
};
</script>

<style lang="scss" scoped>
    @import '@/assets/styles/common/emarticonCard.scss';
    .card-text-wrap { height: 100%;}
</style>